@if (paymentMethod()?.last4) {
  <div class="flex items-center" [matTooltip]="paymentMethod()?.brand">
    <mat-icon class="shrink-0">credit_card</mat-icon>
    <p class="mb-0 ms-1">
      <ng-container i18n>termina en</ng-container> {{ paymentMethod()?.last4 }}
    </p>
  </div>
}
